import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const usersSearchParams = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string(),
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
})

export type UsersSearchParams = z.infer<typeof usersSearchParams>

export const createUsersSearch = ({ orgId, siteId }: UsersSearchParams) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
})
